export default __webpack_public_path__ + "static/media/Top bar.5e10bd60.png";